import React, { useContext } from "react";
import { PropTypes } from "prop-types";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { BannerContents } from "../../../components/shared/layout/banners";
import { LINKS } from "../../../constants";
import { Button } from "../../../components/shared/actions";
import { BannerAplicativos } from "../../../components/blocosCustomizados";
import AccordionContext from "../../../context/AccordionContext";
import imagensPrevidencia from "@asserts/images/previdencia/index";
import "./BannerPrevidencia.css";
import GenericBanner from "../../../components/blocosCustomizados/GenericBanner";
import GuiaButton from "../../../components/shared/actions/GuiaButton";

export const BannerPrevidencia = (props) => {
  const { images } = props;
  const { openAccordion } = useContext(AccordionContext);

  return (
    <BannerContents {...props}>
       <BannerContents.Banner
        right
        className="text-white"
        backgroundImage={imagensPrevidencia.bannerNovaRegraIOF}
      >
        <div className="banner-Bloco">
          <div className="banner-Bloco-left">
            <img
              alt="Alerta"
              src={imagensPrevidencia.alertaBannerNovaRegraIOF}
            />
            <span className="banner-nova-regra-atencao">ATENÇÃO!</span>
          </div>

          <div className="banner-Bloco-right">
            <h4 className="banner-nova-regra-title">
              Novas regras para <br />
              aportes em planos VGBL
            </h4>
            <p className="banner-nova-regra-text">
              A partir de 11/06/2025, contribuições acima de R$ 300 mil em
              planos VGBL, estarão sujeitas à cobrança de 5% de IOF.
            </p>
            <div className="banner-nova-regra-button">
              <Button
                secondary
                blank
                className="mt-2"
                href={LINKS.novaRegraIOF}
              >
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </BannerContents.Banner>
     
      <BannerContents.Banner
        backgroundImage={images.bannerPrevidencia}
        className="text-white"
        right
      >
        <Row>
          <Col xs={12} className="d-flex align-items-stretch">
            <FontAwesomeIcon
              className="d-none d-md-inline-block cvp-icon-banner"
              icon={faPiggyBank}
            />
            <h3 className="d-md-inline-block">Previdência</h3>
          </Col>
          <Col xs={12}>
            <p className="text-body-md mt-0 mt-md-2">
              Uma decisão para se orgulhar lá na frente.
              <br /> Faça agora sem precisar sair de casa
            </p>
            <Button
              className="mt-3"
              blank
              secondary
              href={LINKS.autoCompraPrevidencia}
            >
              Comprar agora
            </Button>
          </Col>
        </Row>
      </BannerContents.Banner>
      <BannerAplicativos
        backgroundImage={images.bannerPrevidenciaApps}
        text={
          <>
            {/* Baixe agora o app Caixa Previdência! */}
            <p>O nosso APP está de cara nova!</p>
            <p>
              <a href="#ja-sou-cliente" onClick={openAccordion}>
                Assista o vídeo
              </a>{" "}
              e confira.
            </p>
          </>
        }
        appleBotao={images.bannerAppleApp}
        androidBotao={images.bannerAndroidApp}
      />
      <GenericBanner
        image={imagensPrevidencia.bannerAssistenciaProtecao}
        text={
          <>
            <div className="margin-top-ajustada">
              <h4 style={{ color: "#F39200", fontSize: "1.6rem" }}>
                ASSISTÊNCIAS QUE VÃO
                <br />
                ALÉM DA PROTEÇÃO
              </h4>
              <p>
                Com os nossos Seguros de Vida e planos de Previdência, você
                conta com assistências exclusivas que facilitam seu dia a dia e
                garantem tranquilidade nos momentos em que mais precisa.
              </p>
              <h4>Conheça os serviços disponíveis.</h4>
            </div>
            <div style={{ marginTop: "32px" }}>
              <GuiaButton href={LINKS.guiaAssistencias2025}>
                BAIXE O GUIA
              </GuiaButton>
            </div>
          </>
        }
        textClassName="text-assistencias"
      />
    </BannerContents>
  );
};

BannerPrevidencia.defaultProps = { images: {} };

BannerPrevidencia.propTypes = {
  images: PropTypes.objectOf(Object)
};

export default BannerPrevidencia;
